const VALIDATION_REGEX = /^[a-z]{2}$/i;
const OFFSET = 127397; // offset between uppercase ascii and regional indicator symbols

const getFlag = (countryCode = 'US') => {
    if (!countryCode || !VALIDATION_REGEX.test(countryCode)) {
        return ''
    }
    const chars = [...countryCode.toUpperCase()].map(c => c.charCodeAt() + OFFSET);
    return String.fromCodePoint(...chars);
}

export default getFlag;